import type { DelayPair } from './types';
import { delayPairLabel } from './delay';
import { iterPngChunks } from './png-chunks';

export interface FctlMeta {
  sequenceNumber: number;
  width: number;
  height: number;
  xOffset: number;
  yOffset: number;
  delayNum: number;
  delayDen: number;
  disposeOp: number;
  blendOp: number;
}

export interface ApngMeta {
  actl: { numFrames: number; numPlays: number } | null;
  fctls: FctlMeta[];
  size: number;
}

export function readApngMeta(buf: Uint8Array): ApngMeta {
  const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
  let actl: ApngMeta['actl'] = null;
  const fctls: FctlMeta[] = [];

  for (const chunk of iterPngChunks(buf)) {
    if (chunk.type === 'acTL' && chunk.length >= 8) {
      actl = {
        numFrames: view.getUint32(chunk.dataStart),
        numPlays: view.getUint32(chunk.dataStart + 4),
      };
    } else if (chunk.type === 'fcTL' && chunk.length >= 26) {
      const ds = chunk.dataStart;
      fctls.push({
        sequenceNumber: view.getUint32(ds),
        width: view.getUint32(ds + 4),
        height: view.getUint32(ds + 8),
        xOffset: view.getUint32(ds + 12),
        yOffset: view.getUint32(ds + 16),
        delayNum: view.getUint16(ds + 20),
        delayDen: view.getUint16(ds + 22),
        disposeOp: view.getUint8(ds + 24),
        blendOp: view.getUint8(ds + 25),
      });
    }
  }

  return { actl, fctls, size: buf.length };
}

export function formatMetaSummary(meta: ApngMeta, delays?: DelayPair[]): string {
  const plays = meta.actl?.numPlays ?? '?';
  const frames = meta.actl?.numFrames ?? meta.fctls.length;
  const parts = meta.fctls.map((f, i) => {
    const pair: DelayPair = delays?.[i] ?? [f.delayNum, f.delayDen];
    return `帧${i}: ${delayPairLabel(pair)} dispose=${f.disposeOp} blend=${f.blendOp}`;
  });
  return `帧数=${frames}，loop/num_plays=${plays}，体积=${(meta.size / 1024).toFixed(1)} KB\n${parts.join('\n')}`;
}
